import { render, staticRenderFns } from "./configurationModule.vue?vue&type=template&id=713d0962&scoped=true&"
import script from "./configurationModule.vue?vue&type=script&lang=js&"
export * from "./configurationModule.vue?vue&type=script&lang=js&"
import style0 from "./configurationModule.vue?vue&type=style&index=0&id=713d0962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713d0962",
  null
  
)

export default component.exports